module.exports = __webpack_public_path__ + "static/media/aai.efaf7f62.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aai.png
// module id = 153
// module chunks = 0